 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"ef6c2f0ba4ccba13fd35f2f390b51531e2be60ab","4":"347c91c90daa2d9864b4f9d4fff47ad3e4c4c2d4","5":"bf36361bf4c414392ec9885b847c567351c4e9cb","8":"component---src-pages-404-js","9":"component---src-pages-barn-2020-guide-js","10":"component---src-pages-barn-2021-guide-js","11":"component---src-pages-barn-index-js","12":"component---src-pages-barn-sammenlign-js","13":"component---src-pages-bat-fritidsbat-2020-guide-js","14":"component---src-pages-bat-fritidsbat-2021-guide-js","15":"component---src-pages-bat-fritidsbat-index-js","16":"component---src-pages-bat-fritidsbat-sammenlign-js","17":"component---src-pages-bat-index-js","18":"component---src-pages-bat-turbat-2020-guide-js","19":"component---src-pages-bat-turbat-2021-guide-js","20":"component---src-pages-bat-turbat-index-js","21":"component---src-pages-bat-turbat-sammenlign-js","22":"component---src-pages-bil-2019-guide-js","23":"component---src-pages-bil-2020-guide-js","24":"component---src-pages-bil-2021-guide-js","25":"component---src-pages-bil-index-js","26":"component---src-pages-bil-sammenlign-js","27":"component---src-pages-hus-2019-guide-js","28":"component---src-pages-hus-2020-guide-js","29":"component---src-pages-hus-2021-guide-js","30":"component---src-pages-hus-index-js","31":"component---src-pages-hus-sammenlign-js","32":"component---src-pages-index-js","33":"component---src-pages-innbo-2019-guide-js","34":"component---src-pages-innbo-2020-guide-js","35":"component---src-pages-innbo-2021-guide-js","36":"component---src-pages-innbo-index-js","37":"component---src-pages-innbo-sammenlign-js","38":"component---src-pages-reise-2019-guide-js","39":"component---src-pages-reise-2020-guide-js","40":"component---src-pages-reise-2021-guide-js","41":"component---src-pages-reise-index-js","42":"component---src-pages-reise-sammenlign-js","43":"component---src-templates-barneforsikring-detaljer-js","44":"component---src-templates-bilforsikring-detaljer-js","45":"component---src-templates-forsikringstilbyder-detaljer-js","46":"component---src-templates-fritidsbatforsikring-detaljer-js","47":"component---src-templates-husforsikring-detaljer-js","48":"component---src-templates-innboforsikring-detaljer-js","49":"component---src-templates-reiseforsikring-detaljer-js","50":"component---src-templates-turbatforsikring-detaljer-js"}[chunkId]||chunkId) + "-" + {"0":"9b32213231c7884230e6","1":"10e7ba3d770ac376025b","2":"2d82ac8e3afc0c213061","3":"8531f153ba2117df4f57","4":"60d641970bcbab480cf6","5":"12f4f4c34fed5a33e265","8":"ccc7af23707d6569dae7","9":"9c09e0dbebf509aea96e","10":"ed5a307b6d5f6fad9792","11":"a927b0395530ef5f8542","12":"e085e303d056dad76241","13":"0402541da63e4e02a420","14":"ba33b00681079a87a226","15":"3387765adc7120ac5ae8","16":"4b876363ff56104e681a","17":"97c534697ad531322dfc","18":"5bf989145e9eaef1eedb","19":"bf8de9cf6eac7847d15d","20":"2513e3f59d8317d0e532","21":"459c13f00554a1202add","22":"501e63618247a701cf85","23":"7a64e64852dcfd5f185a","24":"8c5c1b648db7257cd616","25":"10c391cdd8a883e160da","26":"9733e328d45977a2dd1e","27":"caeb6f7e4fd1f6f88251","28":"122f764126fadd709ab5","29":"cfe476e03c08cbb11367","30":"67aad00cd3f9b63bd2f5","31":"3eef0f0b0f2cd4187a27","32":"33f137420085c9c3652d","33":"9584e57c996b36305708","34":"b5d675de8a9c50fd23a9","35":"766bb646979de70f8c5b","36":"812d25041311684d49b1","37":"f1e4b1abeb4b95c39995","38":"eed3b5d333dd36e39c24","39":"98339fec6b37da912b85","40":"9bdd39748d6a7bf34bf4","41":"336fef701ca5a2beb95a","42":"b9fded30cdeef7589d47","43":"e739927a462f893e82a4","44":"bf0a907f7c77cdf1d3b3","45":"637b8e6efd7acc5bbd77","46":"2852e278947881b5dfdc","47":"d726b90d66c935251442","48":"30c3d2fb4d63c0e116c3","49":"3ba162b63cdbd0adc7e1","50":"7d363bcbd8782103d0cd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"ef6c2f0ba4ccba13fd35f2f390b51531e2be60ab","4":"347c91c90daa2d9864b4f9d4fff47ad3e4c4c2d4","5":"bf36361bf4c414392ec9885b847c567351c4e9cb","8":"component---src-pages-404-js","9":"component---src-pages-barn-2020-guide-js","10":"component---src-pages-barn-2021-guide-js","11":"component---src-pages-barn-index-js","12":"component---src-pages-barn-sammenlign-js","13":"component---src-pages-bat-fritidsbat-2020-guide-js","14":"component---src-pages-bat-fritidsbat-2021-guide-js","15":"component---src-pages-bat-fritidsbat-index-js","16":"component---src-pages-bat-fritidsbat-sammenlign-js","17":"component---src-pages-bat-index-js","18":"component---src-pages-bat-turbat-2020-guide-js","19":"component---src-pages-bat-turbat-2021-guide-js","20":"component---src-pages-bat-turbat-index-js","21":"component---src-pages-bat-turbat-sammenlign-js","22":"component---src-pages-bil-2019-guide-js","23":"component---src-pages-bil-2020-guide-js","24":"component---src-pages-bil-2021-guide-js","25":"component---src-pages-bil-index-js","26":"component---src-pages-bil-sammenlign-js","27":"component---src-pages-hus-2019-guide-js","28":"component---src-pages-hus-2020-guide-js","29":"component---src-pages-hus-2021-guide-js","30":"component---src-pages-hus-index-js","31":"component---src-pages-hus-sammenlign-js","32":"component---src-pages-index-js","33":"component---src-pages-innbo-2019-guide-js","34":"component---src-pages-innbo-2020-guide-js","35":"component---src-pages-innbo-2021-guide-js","36":"component---src-pages-innbo-index-js","37":"component---src-pages-innbo-sammenlign-js","38":"component---src-pages-reise-2019-guide-js","39":"component---src-pages-reise-2020-guide-js","40":"component---src-pages-reise-2021-guide-js","41":"component---src-pages-reise-index-js","42":"component---src-pages-reise-sammenlign-js","43":"component---src-templates-barneforsikring-detaljer-js","44":"component---src-templates-bilforsikring-detaljer-js","45":"component---src-templates-forsikringstilbyder-detaljer-js","46":"component---src-templates-fritidsbatforsikring-detaljer-js","47":"component---src-templates-husforsikring-detaljer-js","48":"component---src-templates-innboforsikring-detaljer-js","49":"component---src-templates-reiseforsikring-detaljer-js","50":"component---src-templates-turbatforsikring-detaljer-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"93db76fca99b824273fa","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
